import type React from 'react'

import { useCallback, useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { PopupContent } from './PopupPortal.styled'

export interface IPopupPortal {
  children: React.ReactNode | React.ReactNode[]
  wrapperId?: string
}

export const PopupPortal = ({
  children,
  wrapperId = 'popup-portal',
}: IPopupPortal) => {
  const nodeRef = useRef(null)
  const createWrapperAndAppendToBody = useCallback((wrapperId: string) => {
    const wrapperElement = document.createElement('div')
    wrapperElement.setAttribute('id', wrapperId)
    document.body.appendChild(wrapperElement)
    return wrapperElement
  }, [])
  const Portal = ({ children, wrapperId }: any) => {
    const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(
      null
    )
    const [createElement, setCreateElement] = useState(false)

    useLayoutEffect(() => {
      let element = document.getElementById(wrapperId)
      if (!element) {
        setCreateElement(true)
        element = createWrapperAndAppendToBody(wrapperId)
      }
      setWrapperElement(element)

      return () => {
        if (createElement && element!.parentNode) {
          element!.parentNode.removeChild(element!)
        }
      }
    }, [wrapperId])

    if (wrapperElement === null) return null

    return createPortal(children, wrapperElement)
  }
  return (
    <Portal wrapperId={wrapperId}>
      <PopupContent ref={nodeRef}>{children}</PopupContent>
    </Portal>
  )
}
